import { Avatar, Breadcrumb, Button, Dropdown, Image, Tag } from "antd";
import { AngleRight } from "../../../../../atoms/CustomIcons";
import { MoreOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import { getContractDetailType } from "../../../ducks/types";
import { useRef, useState } from "react";
import { SuccessMessage } from "../../../../../atoms/Toasts/SuccessMessage";
import { PopUp } from "../../../../../atoms/PopUp";
import ConfirmDelete from "../../../../../atoms/ConfirmDelete";
import { ErrorMessage } from "../../../../../atoms/Toasts/ErrorMessage";
import { AxiosError } from "axios";
import { contractUnwin } from "../../../ducks/services";
import TerminatePopUp from "../../../Components/TerminatePopUp";

interface BreadcrumbItem {
  label: string;
  href?: string;
}
interface HeaderProps {
  title: string;
  description?: string | React.ReactNode;
  btnText1?: string;
  btnIcon1?: JSX.Element;
  btnText2?: string;
  breadcrumb?: BreadcrumbItem[];
  imageIcon?: string;
  avatarColor?: string;
  avatarIcon?: React.ReactNode;
  propertyName: string;
  propertyClientName: string;
  detailData: getContractDetailType | null;
  loading: boolean;
  setLoading: React.Dispatch<React.SetStateAction<boolean>>;
}

export default function DashboardHeader({
  title,
  description,
  btnText1,
  btnIcon1,
  btnText2,
  breadcrumb = [],
  imageIcon,
  avatarIcon,
  avatarColor,
  propertyName,
  propertyClientName,
  detailData,
  loading,
  setLoading,
}: HeaderProps) {
  const navigate = useNavigate();
  const location = window.location.pathname;
  const pathSegments = location.split("/");
  const companyId = pathSegments[pathSegments.length - 1];
  const contractId = pathSegments[pathSegments.length - 2];
  const dropdownRef = useRef<HTMLButtonElement>(null);
  const [isTerminateModalOpen, setIsTerminateModalOpen] = useState(false);
  const [isUnWinModalOpen, setIsUnWinModalOpen] = useState(false);

  const items = [
    // {
    //   key: "1",
    //   label: (
    //     <Button
    //       type="text"
    //       className="no-hover"
    //       onClick={(e) => {
    //         e.stopPropagation();
    //         navigate(
    //           `/edit-contracts/${detailData?.id}/${detailData?.current_accepted_proposal_id}/${detailData?.deal_id}/${companyId}`
    //         );
    //       }}
    //       icon={<Image src="/images/contracts/edit.svg" preview={false} />}
    //     >
    //       Edit details
    //     </Button>
    //   ),
    // },
    {
      key: "2",
      label: (
        <Button
          type="text"
          className="no-hover"
          onClick={(e) => {
            e.stopPropagation();
            navigate(
              `/create-upsale/${detailData?.id}/${detailData?.current_accepted_proposal_id}/${detailData?.deal_id}/${companyId}`
            );
          }}
          icon={<Image src="/images/contracts/upsale.svg" preview={false} />}
        >
          Upsell
        </Button>
      ),
    },
    {
      key: "3",
      label: (
        <Button
          type="text"
          className="no-hover"
          onClick={(e) => {
            e.stopPropagation();
            navigate(
              `/change-order/${detailData?.id}/${detailData?.current_accepted_proposal_id}/${detailData?.deal_id}/${companyId}`
            );
          }}
          icon={
            <Image src="/images/contracts/change-order.svg" preview={false} />
          }
        >
          Change order
        </Button>
      ),
    },
    {
      key: "4",
      disable: true,
      label: (
        <Button
          type="text"
          className="no-hover"
          onClick={(e) => {
            e.stopPropagation();
            setIsUnWinModalOpen(true);
            if (dropdownRef.current) {
              dropdownRef?.current?.click();
            }
          }}
          disabled={true}
          icon={<Image src="/images/contracts/unwin.svg" preview={false} />}
        >
          Unwin
        </Button>
      ),
    },
    {
      key: "5",
      disable: true,
      label: (
        <Button
          type="text"
          className="no-hover"
          onClick={(e) => {
            e.stopPropagation();
            setIsTerminateModalOpen(true);
            if (dropdownRef.current) {
              dropdownRef?.current?.click();
            }
          }}
          disabled={true}
          icon={<Image src="/images/contracts/terminate.svg" preview={false} />}
        >
          Terminate
        </Button>
      ),
    },
    {
      key: "6",
      disable: true,
      label: (
        <Button
          type="text"
          className="no-hover"
          onClick={(e) => {
            e.stopPropagation();
          }}
          disabled={true}
          icon={<Image src="/images/contracts/renew.svg" preview={false} />}
        >
          Renew
        </Button>
      ),
    },
  ];

  const terminateFunction = () => {
    setLoading(true);

    setTimeout(() => {
      setLoading(false);
      setIsTerminateModalOpen(false);
      SuccessMessage("Contract terminated");
    }, 1000);
  };

  const terminateClientPopUp = {
    visibility: isTerminateModalOpen,
    content: (
      <TerminatePopUp
        onClose={() => setIsTerminateModalOpen(false)}
        btnApi={terminateFunction}
        loading={loading}
      />
    ),
    width: 756,
    onCancel: () => setIsTerminateModalOpen(false),
  };

  const unWinFunction = () => {
    setLoading(true);
    contractUnwin([contractId])
      .then(() => {
        setLoading(false);
        setIsUnWinModalOpen(false);
        navigate(`/contracts/${companyId}`);
        SuccessMessage("Contract reverted");
      })
      .catch((e: unknown) => {
        if (e instanceof AxiosError) {
          setLoading(false);
          ErrorMessage(
            e?.response?.data?.error?.message ?? "Something went wrong"
          );
        } else {
          setLoading(false);
          ErrorMessage("Something went wrong");
        }
      });
  };

  const unWinClientPopUp = {
    visibility: isUnWinModalOpen,
    content: (
      <ConfirmDelete
        title=""
        onClose={() => setIsUnWinModalOpen(false)}
        heading="Confirm unwin action"
        isArchivePopup
        paragraph={
          <>
            This will remove the contract and revert it back to a potential
            deal. All tasks, checklist items, and documents added after it was
            won will be deleted.
            <br /> <br />
            Use this if the contract was sent to production by mistake.
          </>
        }
        btnText="Unwin contract"
        btnApi={unWinFunction}
        loading={loading}
      />
    ),
    width: 480,
    onCancel: () => setIsUnWinModalOpen(false),
  };

  return (
    <>
      <div className="profileHeader">
        <div className="headerLeft">
          {breadcrumb.length > 0 && (
            <Breadcrumb
              separator={<AngleRight />}
              style={{ marginBottom: "12px" }}
            >
              <Breadcrumb.Item>
                <a href={`/contracts/${companyId}`}> Contracts </a>
              </Breadcrumb.Item>
              <Breadcrumb.Item>Contract details</Breadcrumb.Item>
            </Breadcrumb>
          )}
          {imageIcon || avatarIcon ? (
            <div className="headerContentWithImage">
              {imageIcon && <Image src={imageIcon} preview={false} />}
              {avatarIcon && (
                <Avatar
                  size={58}
                  className={avatarColor}
                  shape="square"
                  src={avatarIcon}
                />
              )}
              <div>
                <h2>{title}</h2>
                {description && <p>{description}</p>}
              </div>
            </div>
          ) : (
            <>
              <h2>{title}</h2>
              {description && <p>{description}</p>}
              <div
                style={{ display: "flex", gap: "8px", alignItems: "center" }}
              >
                <span
                  style={{
                    fontSize: "14px",
                    lineHeight: "20px",
                    fontWeight: "400",
                    color: "#6454F4",
                    display: "flex",
                    alignItems: "center",
                    gap: "5px",
                    marginRight: "8px",
                  }}
                >
                  <img src="/images/estimate/building-icon.svg" alt="" />
                  {propertyName}
                </span>
                <span
                  style={{
                    fontSize: "14px",
                    lineHeight: "20px",
                    fontWeight: "400",
                    color: "#474C4D",
                    display: "flex",
                    alignItems: "center",
                    gap: "5px",
                  }}
                >
                  <img src="/images/estimate/clients-icon.svg" alt="" />
                  {propertyClientName}
                </span>
              </div>
            </>
          )}
        </div>

        <div className="headerRight" style={{ marginTop: 14 }}>
          <Tag
            className="accepted_tag"
            style={{
              marginRight: "8px",
              padding: "8px 16px",
              borderRadius: "10px",
              fontWeight: 600,
              fontSize: "15px",
              lineHeight: "20px",
            }}
          >
            Active
          </Tag>
          <Dropdown
            menu={{ items }}
            trigger={["click"]}
            placement="bottomRight"
            className="actionButton"
          >
            <Button
              onClick={(x) => {
                x.stopPropagation();
              }}
              onKeyDown={(e) => e.stopPropagation()}
              style={{
                padding: "0px",
                height: "36px",
                width: "36px",
                backgroundColor: "transparent",
                border: "1px solid #DEE5E6",
                borderRadius: "8px",
              }}
              className="only_icon"
              icon={<MoreOutlined />}
              ref={dropdownRef}
            />
          </Dropdown>
        </div>

        {(btnText1 || btnText2) && (
          <div className="two_btns">
            {btnText1 && (
              <Button htmlType="submit" size="large" className="btn-sm">
                {btnIcon1 && btnIcon1} {btnText1}
              </Button>
            )}
            {btnText2 && (
              <Button htmlType="submit" size="large" className="outlined-btn">
                {btnText2}
              </Button>
            )}
          </div>
        )}
      </div>

      <PopUp {...terminateClientPopUp} />
      <PopUp {...unWinClientPopUp} />
    </>
  );
}
